import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NewsComponent } from './news.component';
import { NewsDetailComponent } from './component/news-detail.component';
import { FutureEventsComponent } from './component/future-events/future-events.component';
import { PastEventsComponent } from './component/past-events/past-events.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    NewsComponent,
    NewsDetailComponent,
    FutureEventsComponent,
    PastEventsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SharedModule
  ],
  exports: [
    NewsComponent,
    NewsDetailComponent,
    FutureEventsComponent,
    PastEventsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EventsModule { }
